import "./Contact_Us.css";
import Common_Title from "../common_component/common_title/Common_Title";
import { Form } from "react-bootstrap";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faFacebookF,
  faInstagram,
  faWhatsapp,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

import Common_Btn_Yellow from "../common_component/common_btn_yellow/Common_Btn_Yellow";
import Success_Modal from "./success_modal/Success_Modal";
import { postData } from "../../utils/api";

const Contact_Us = () => {
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    try {
      const response = await postData("/master/contact-us/", formData);

      if (response?.success) {
        setShowSuccessModal(true);

        setTimeout(() => {
          setShowSuccessModal(false);
        }, 3000);

        setFormData({
          full_name: "",
          email: "",
          phone: "",
          message: "",
        });
      } else {
        alert(response?.message || "Something went wrong");
      }
    } catch (error) {
      console.log(error);
      alert("Server error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-banner">
        <h2>Contact Us</h2>
      </div>

      <section className="contact-section">
        <div className="container">
          <div className="contact-heading">
            <Common_Title title="Send Us a Message" />
            <p>
              Reach out for bookings, travel guidance, custom packages, or any
              journey support. We're happy to help.
            </p>
          </div>

          <div className="contact-card">
            <div className="row">
              {/* CONTACT FORM */}
              <div className="col-lg-6">
                <Form className="contact-form" onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter your full name"
                      name="full_name"
                      value={formData.full_name}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter your email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Contact Number</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter your number"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      placeholder="Enter your message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Common_Btn_Yellow
                    type="submit"
                    disabled={isSubmitting}
                    text={isSubmitting ? "Sending..." : "Submit Now"}
                  />
                </Form>
              </div>

              {/* CONTACT INFO */}
              <div className="col-lg-6">
                <div className="contact-info">
                  <h5>Get in touch</h5>

                  <div className="info-box">
                    <strong>
                      <span className="icon-box">
                        <i className="fa-solid fa-location-dot"></i>
                      </span>
                      Address
                    </strong>

                    <p>
                      Akshya Nagar 1st Block 1st Cross,
                      <br />
                      Rammurthy nagar, Bangalore-560016
                    </p>
                  </div>

                  <div className="info-box">
                    <strong>
                      <span className="icon-box">
                        <i className="fa-solid fa-envelope"></i>
                      </span>
                      Email
                    </strong>

                    <p>adeshtourstravels@gmail.com</p>
                  </div>

                  <div className="info-box">
                    <strong>
                      <span className="icon-box">
                        <i className="fa-solid fa-phone"></i>
                      </span>
                      Phone Number
                    </strong>

                    <p>+91 6956545212</p>
                  </div>

                  {/* SOCIAL ICONS */}
                  <div className="social-icons">
                    {[
                      { icon: faInstagram, link: "https://www.instagram.com" },
                      { icon: faWhatsapp, link: "https://wa.me/1234567890" },
                      { icon: faFacebookF, link: "https://www.facebook.com" },
                      { icon: faYoutube, link: "https://www.youtube.com" },
                    ].map((item, index) => (
                      <a
                        key={index}
                        href={item.link}
                        className="icon_link"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FontAwesomeIcon
                          icon={item.icon}
                          className="footer_icon"
                          style={{ color: "#000", fontSize: "22px" }}
                        />
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Success_Modal
            show={showSuccessModal}
            handleClose={() => setShowSuccessModal(false)}
          />
        </div>
      </section>

      {/* MAP */}
      <div className="map-section">
        <iframe
          title="map"
          src="https://maps.google.com/maps?output=embed"
          width="100%"
          height="400"
          style={{ border: 0 }}
          loading="lazy"
        ></iframe>
      </div>
    </div>
  );
};

export default Contact_Us;
